export const API_ROUTE = "/api"

export const SUBMIT_ELIGIBILITY_ROUTE = API_ROUTE + "/eligibility"
export const SUBMIT_CONTACT_FORM_ROUTE = API_ROUTE + "/contact-form"
export const SUBMIT_PROPERTY_CONTACT_FORM_ROUTE = SUBMIT_CONTACT_FORM_ROUTE + "/property"

export const UPLOAD_ROUTE = API_ROUTE + "/upload"

export const PROPERTY_ROUTE = API_ROUTE + "/properties"
export const PROPERTY_SHARE_ROUTE = PROPERTY_ROUTE + "/share"

export const COMPLEX_ROUTE = API_ROUTE + "/complexes"
export const COMPLEX_CONTRACT_ROUTE = COMPLEX_ROUTE + "/contract";
export const COMPLEX_WITH_PROPERTIES_ROUTE = COMPLEX_ROUTE + "/:id/properties";

export const OFFER_APPLY_ROUTE = API_ROUTE + "/offers/apply"